<template>
  <div class="r-edit-tip-modal">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="change-password">{{ $t("order.editTip") }}</div>
        <div class="individual-account">
          {{ $t("order.myOrder") }}
        </div>
        <!-- Existing Classify -->
        <div class="existing-classify" v-if="tipList.length > 0">
          {{ $t("order.existingClassify") }}
        </div>
        <div class="common-flex common-flex-wrap" v-if="tipList.length > 0">
          <div
            @click="toggleLabel(item)"
            class="tip-item common-flex common-align-center common-hover"
            :style="[
              isLabelSelected(item.id)
                ? { backgroundColor: item.color, color: '#fff', border: 'none' }
                : { color: item.color, borderColor: item.color },
            ]"
            v-for="(item, index) in tipList"
            :key="index"
          >
            <div class="tip-name">{{ item.content }}</div>
            <Icon type="ios-close" size="18" style="font-weight: bolder" v-if="!isLabelSelected(item.id)" @click.stop="deleteTag(item)"/>
          </div>
        </div>
        <!-- Tag color -->
        <div class="common-flex common-align-center" style="margin-top: 40px">
          <div class="tip-title">{{ $t("order.tagColor") }}</div>
          <div class="tip-colors common-flex">
            <div
              class="color-item common-hover"
              :style="{ backgroundColor: item.name }"
              v-for="(item, index) in colors"
              :key="index"
              @click="changeColor(item)"
            >
              <div
                v-if="params.color == item.name"
                :style="{ border: '1px solid ' + item.name }"
                class="color-item-solid"
              ></div>
            </div>
          </div>
        </div>
        <!-- Tag text -->
        <div class="common-flex tag-text common-align-center">
          <div class="tag-text-title">{{ $t("order.tagText") }}</div>
          <input type="text" v-model="params.content" />
          <div class="continue-add common-hover" @click="saveOrderLabel">
            添加
          </div>
        </div>

        <!-- Selected Labels Preview -->
        <div class="selected-labels-section" v-if="selectedLabels.length > 0">
          <div class="selected-labels-title">已选择的标签</div>
          <div class="selected-labels-container common-flex common-flex-wrap">
            <div 
              v-for="(label, index) in selectedLabels" 
              :key="'selected-'+index"
              class="selected-label"
              :style="{ 
                backgroundColor: label.color + '30', 
                color: getTextColor(label.color),
                borderColor: label.color
              }"
            >
              {{ label.content }}
              <Icon 
                type="ios-close" 
                size="16" 
                @click="removeSelectedLabel(index)"
                class="remove-label-icon"
              />
            </div>
          </div>
        </div>

        <div class="common-flex common-flex-end">
          <div class="back common-hover" @click="closeModal">
            取消
          </div>
          <div class="submit common-hover" @click="submitMultipleLabels">
            确认
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-edit-tip-modal",
  data() {
    return {
      params: {
        color: "",
        content: "",
        type: "",
      },
      submitLabel: {
        orderId: "",
        labelIds: ""
      },
      selectedLabels: [],
      show: false,
      colorId: "",
      "colors": [
        {
          "name": "#FF5733", // 明亮的橙色
          "id": 1
        },
        {
          "name": "#008080", // 青色（Teal）
          "id": 2
        },
        {
          "name": "#673AB7", // 深紫色
          "id": 3
        },
        {
          "name": "#FFD166", // 鲜黄色
          "id": 4
        },
        {
          "name": "#E91E63", // 明亮的粉红色
          "id": 5
        },
        {
          "name": "#4CAF50", // 鲜绿色
          "id": 6
        },
        {
          "name": "#2196F3", // 亮蓝色
          "id": 7
        },
        {
          "name": "#9E9D24", // 橄榄绿
          "id": 8
        },
        {
          "name": "#795548", // 棕色
          "id": 9
        }
      ],
      tipList: [],
    };
  },
  watch: {
    tipShow: {
      handler(newval, oldval) {
        this.show = newval;
        if (newval) {
          this.params.color = "#D87508";
          this.params.content = "";
          this.params.type = "";
          this.submitLabel.orderId = this.chooseOrderId;
          this.selectedLabels = [];
          
          // 如果有已有标签，加载到选中列表
          if (this.chooseContent) {
            // 这里假设chooseContent是标签的字符串表示，需要根据实际数据格式调整
            const existingLabels = Array.isArray(this.chooseContent) ? this.chooseContent : [];
            
            existingLabels.forEach(label => {
              const foundLabel = this.tipList.find(tip => tip.id === label.id);
              if (foundLabel) {
                this.selectedLabels.push(foundLabel);
              }
            });
          }
        }
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.getLabelList();
          this.$emit("handlerTipShow", newval);
        }
        this.params.color = "#D87508";
        this.params.content = "";
        this.params.type = "";
      },
      immediate: true,
    },
  },
  mounted() {
    this.getLabelList();
  },
  methods: {
    ...mapActions([
      "getLabelListAction", //标签列表
      "saveOrderLabelAction", //保存标签
      "saveOrderLabelsAction", //关联订单标签
      "deleteLabelAction", //删除标签
    ]),
    
    // 判断文本颜色
    getTextColor(hex) {
      if (!hex) return '#000000';
      let r = parseInt(hex.slice(1, 3), 16);
      let g = parseInt(hex.slice(3, 5), 16);
      let b = parseInt(hex.slice(5, 7), 16);

      // 计算颜色亮度（0-255）
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // 根据亮度自动调整文字颜色
      return brightness > 186 ? '#000000' : hex;
    },
    
    // 关闭模态框
    closeModal() {
      this.show = false;
    },
    
    // 检查标签是否被选中
    isLabelSelected(labelId) {
      return this.selectedLabels.some(label => label.id === labelId);
    },
    
    // 切换标签选择状态
    toggleLabel(label) {
      const index = this.selectedLabels.findIndex(item => item.id === label.id);
      if (index === -1) {
        // 添加到选中列表
        this.selectedLabels.push(label);
      } else {
        // 从选中列表移除
        this.selectedLabels.splice(index, 1);
      }
    },
    
    // 移除已选标签
    removeSelectedLabel(index) {
      this.selectedLabels.splice(index, 1);
    },
    
    // 提交多个标签
    submitMultipleLabels() {
      if (this.selectedLabels.length === 0) {
        this.$Message.warning('请至少选择一个标签');
        return;
      }
      
      const labelIds = this.selectedLabels.map(label => label.id).join(',');
      this.submitLabel.labelIds = labelIds;
      
      this.saveOrderLabelsAction(this.submitLabel).then((res) => {
        if (res.code == 0) {
          this.$Message.success('标签已更新');
          this.$emit("updateCart");
          this.show = false;
        } else {
          this.$Message.error(res.message || '更新失败');
        }
      });
    },
    
    // 保存新标签
    saveOrderLabel() {
      this.params.type = this.tipType;
      if (this.params.color == "") {
        this.$Message.error(this.$t("cart.pleaseColor"));
      } else if (this.params.content == "") {
        this.$Message.error(this.$t("cart.fillContent"));
      } else {
        this.saveOrderLabelAction(this.params).then((res) => {
          if (res.code == 0) {
            this.getLabelList();
            this.$Message.success('新标签已创建');
            // 创建后自动选中
            this.selectedLabels.push(res.data);
          }
        });
      }
    },
    
    getLabelList() {
      this.getLabelListAction({ type: "cart" }).then((res) => {
        this.tipList = res.data;
      });
    },
    
    // 修改颜色
    changeColor(e) {
      this.params.color = e.name;
    },
    
    //删除标签
    deleteTag(e){
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: 'The delete operation will clear all orders that have marked this label. Do you want to delete it?',
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: async () => {
          this.deleteLabelAction(e.id).then((res) => {
            if (res.code == 0) {
              this.$Message.success('deleted successful');
              
              // 从已选列表中也移除
              const index = this.selectedLabels.findIndex(item => item.id === e.id);
              if (index !== -1) {
                this.selectedLabels.splice(index, 1);
              }
              
              this.$emit("updateCart", true);
              this.getLabelList();
            }
          });
        },
      });
    }
  },
  props: {
    tipShow: Boolean,
    tipType: String,
    chooseOrderId: [Number, String],
    chooseContent: [Number, String, Array, Object],
  },
};
</script>

<style scoped lang="less">
/deep/.ivu-input {
  border: none;
}
/deep/.ivu-modal-body {
  padding-bottom: 0;
}
/deep/.ivu-modal-mask {
  z-index: 99 !important;
}
/deep/.ivu-modal-wrap {
  z-index: 99 !important;
}
.tip-item {
  // width: 120px;
  // height: 30px;
  padding: 4px 8px;
  margin-right: 8px;
  margin-bottom: 12px;
  border: 1px solid #999;
  border-radius: 4px;
  .tip-name {
    font-size: 12px;
    // margin-right: 40px;
  }
  .iconguanbi {
    font-size: 12px;
    // transform: scale(0.83);
  }
}
.add-tip {
  text-align: center;
  width: 120px;
  height: 30px;
  line-height: 30px;
  // opacity: 0.3;
  color: #081938;
  border: 1px dashed rgba(8, 25, 56, 0.3);
  border-radius: 5px;
  font-size: 12px;
  .iconzengjiashuliang {
    font-size: rgba(8, 25, 56, 0.7);
  }
}
.tag-text {
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(8, 25, 56, 0.1);
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  text-align: left;
  color: #333333;
  line-height: 20px;
  width: 504px;
  margin: 45px 0 20px;
  .tag-text-title {
    width: 120px;
    margin-right: 20px;
  }
  input {
    width: 169px;
    margin-right: 94px;
  }
  .continue-add {
    width: 101px;
    height: 26px;
    line-height: 26px;
    background: rgba(10, 77, 204, 0.1);
    color: #0a4dcc;
    font-size: 12px;
    text-align: center;
  }
}
.tip-title {
  width: 120px;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  text-align: left;
  color: #333333;
  line-height: 16px;
  margin-right: 23px;
}
.tip-colors {
  width: 450px;
  .color-item {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 20px;

    position: relative;
    .color-item-solid {
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      top: -3px;
      left: -3px;
    }
  }
}
.password-box {
  // height: 508px;
  width: 620px;
  padding: 14px 24px;
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }
  .change-password {
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    font-family: Times, Times-Bold;
    color: #000000;
    line-height: 37px;
    margin-bottom: 3px;
  }
  .individual-account {
    font-size: 12px;
    font-family: Times, Times-Roman;
    font-weight: Roman;
    text-align: left;
    color: #666666;
    line-height: 14px;
    margin-bottom: 40px;
  }
  .existing-classify {
    font-size: 14px;
    font-family: Roboto, Roboto-Regular;
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 16px;
    margin-bottom: 10px;
  }
}

// 新增样式
.selected-labels-section {
  margin-top: 20px;
  margin-bottom: 30px;
  
  .selected-labels-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #333333;
  }
  
  .selected-labels-container {
    padding: 10px;
    background-color: #f8f8f8;
    border-radius: 4px;
    
    .selected-label {
      padding: 5px 10px;
      border-radius: 4px;
      margin-right: 8px;
      margin-bottom: 8px;
      font-size: 12px;
      border: 1px solid;
      display: flex;
      align-items: center;
      
      .remove-label-icon {
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-edit-tip-modal.vue